import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Form from 'components/form'
import { UseFormReturn } from 'react-hook-form'
import CountrySelectListbox from '../../../form/CountrySelectListbox'
import { RestUser } from 'data/types/user'
import { RestUserInput } from 'data/types/input'
import { Country } from 'countries-list'

interface EditDetailsProps extends UseFormReturn<RestUserInput> {
  user: RestUser
}

const EditDetails = ({
  setValue,
  register,
  watch,
  getValues,
  formState: { errors },
}: EditDetailsProps) => {
  const [selectedCountry, setSelectedCountry] = useState<Country | null | undefined>(null)

  useEffect(() => {
    if (selectedCountry) {
      setValue('address.country', selectedCountry.name)
    }
  }, [selectedCountry])


  return (
    <div className="grid grid-cols-3 font-normal gap-15 xl:ml-20">
      <div className="flex items-center text-grey-900">Name:</div>
      <div className="col-span-2 text-grey-700">
        <Form.Input className="!h-[44px]"  {...register('first_name')} style="customer" />
      </div>
      <div className="flex items-center text-grey-900">Last Name:</div>
      <div className="col-span-2 text-grey-700">
        <Form.Input className="!h-[44px]" {...register('last_name')} style="customer" />
      </div>
      <div className="flex items-center text-grey-900">Email:</div>
      <div className="col-span-2 text-grey-700">
        <Form.Input className="!h-[44px]" {...register('email')} style="customer" />
      </div>
      <div className="flex items-center text-grey-900">Phone:</div>
      <div className="grid grid-cols-3 col-span-2 gap-10 text-grey-700">
        <Form.CountryCodeSelect

          onChange={(input) => setValue('phone_country_code', input)}
          value={watch('phone_country_code')}
          className="-left-150 w-200"
          buttonClassName="!h-[44px]"
        />
        <div className="col-span-2">
          <Form.Input
            style="customer"
            className="!h-[44px]"
            {...register('phone')}
            error={errors?.phone?.message}
            type="tel"
          />
        </div>
      </div>

      <div className="pt-10 text-grey-900">Address:</div>

      <div className="flex flex-col col-span-2 gap-10 text-grey-700 mb-15">
        <Form.Input
          style="customer"
          className="!h-[44px]"
          label="Line 1"
          {...register('address.line_1')}
          defaultValue={getValues('address.line_1') ?? undefined}

        />

        <Form.Input
          style="customer"
          className="!h-[44px]"
          label="Line 2"
          {...register('address.line_2')}
          defaultValue={getValues('address.line_2') ?? undefined}
        />

        <Form.Input
          style="customer"
          className="!h-[44px]"
          label="Postcode"
          {...register('address.postcode')}
          defaultValue={getValues('address.postcode') ?? undefined}
        />

        <Form.Input
          style="customer"
          className="!h-[44px]"
          label="City"
          {...register('address.city')}
          defaultValue={getValues('address.city') ?? undefined}
        />

        <Form.Input
          style="customer"
          className="!h-[44px]"
          label="State"
          {...register('address.state')}
          defaultValue={getValues('address.state') ?? undefined}
        />

        <CountrySelectListbox
          style="customer"
          label="Country"
          setSelectedCountry={setSelectedCountry}
          selectedCountry={selectedCountry}
          initialCountry={getValues('address.country') ?? null}
        />
      </div>
    </div>
  )
}

EditDetails.propTypes = {
  setContents: PropTypes.func,
  user: PropTypes.object,
}

export default EditDetails
